<div class="chart-container">
  <div class="score-tooltip-barChart" [ngStyle]="{left: tooltipX + 'px', top: tooltipY + 'px', display: tooltipVisible}">
    <div class="tooltipHeading">{{ tooltipHeading }}</div>
    <div>
      <div class="caret border-bottom" *ngIf="tooltipData?.response != null && tooltipData?.response !== ''">
        <div class="tooltipLabel">Responses</div>
        <div class="tooltipValue">{{ tooltipData.response }}</div>
      </div>
      <div class="caret" *ngFor="let dataPoint of tooltipData?.dataPoints; let last = last" [ngClass]="{'border-bottom': !last}">
         <div class="tooltipLabel"><span [innerHTML]=" dataPoint.label"></span></div> 
        <div class="tooltipValue">{{ dataPoint.value }}</div> 
      </div>
    </div>
  </div> 
  <canvas #chartCanvas class="graph"></canvas>
   <div id="custom-legend" class="custom-legend-container" *ngIf="legend">
    <div 
      *ngFor="let legendItem of legendItems; let i = index" 
      class="custom-legend-item" 
      (click)="toggleDatasetVisibility(i)"
      [ngClass]="{
        'underlined': isNoneSelected(),
        'selected': isSelected(i) && !isNoneSelected(),
        'deselected': !isSelected(i) && isAnyVisible() && !isNoneSelected()
      }"
      [style.cursor]="legendItems.length <= 1 ? 'default' : 'pointer'">
      <div 
        class="legend-color-box" 
        [style.backgroundColor]="legendItem.borderColor"
        [ngClass]="{
          'deselected': !isSelected(i) && isAnyVisible() && !isNoneSelected()
        }"
      ></div>
      <span class="legend-label">{{ legendItem.label }}</span>
    </div>
  </div>
</div>